import authentication from '@/views/authentication/authentication';
export default authentication;